const FALLBACK_PORTS = [5001, 5002, 5003];
const STORAGE_KEY = 'erp_api_origin';

const isBrowser = typeof window !== 'undefined';

function normalizeOrigin(value) {
  if (!value || typeof value !== 'string') return null;
  return value.trim().replace(/\/+$/, '');
}

function isCloudEnvironment() {
  if (!isBrowser) return false;
  return (
    window.location.protocol === 'https:' ||
    window.location.hostname.includes('onrender.com') ||
    window.location.hostname.includes('vercel.app') ||
    window.location.hostname.includes('fly.dev')
  );
}

function getDefaultOrigin() {
  if (!isBrowser) return '';
  if (isCloudEnvironment()) {
    return window.location.origin;
  }
  const hostname = window.location.hostname || 'localhost';
  return `http://${hostname}:5001`;
}

function getOriginFromEnv() {
  const raw = process.env.REACT_APP_API_URL;
  if (!raw) return null;
  return normalizeOrigin(raw.replace(/\/api\/?$/, ''));
}

function getOriginFromStorage() {
  if (!isBrowser) return null;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (!stored) return null;

  // Se estiver em nuvem/HTTPS ou se o storage tiver URL antiga com porta inválida, descarta
  if (isCloudEnvironment() || stored.includes('onrender.com') || stored.startsWith('http:')) {
    window.localStorage.removeItem(STORAGE_KEY);
    return null;
  }
  return normalizeOrigin(stored);
}

function getFallbackOrigins() {
  if (!isBrowser) return [];
  if (isCloudEnvironment()) {
    return [window.location.origin];
  }
  const hostname = window.location.hostname || 'localhost';
  return FALLBACK_PORTS.map((port) => `http://${hostname}:${port}`);
}

function unique(values) {
  const seen = new Set();
  const output = [];

  values.forEach((value) => {
    if (!value || seen.has(value)) return;
    seen.add(value);
    output.push(value);
  });

  return output;
}

export function getApiOriginCandidates() {
  if (isCloudEnvironment()) {
    return [window.location.origin];
  }
  return unique([
    getOriginFromEnv(),
    getOriginFromStorage(),
    getDefaultOrigin(),
    ...getFallbackOrigins(),
  ]);
}

export function getInitialApiOrigin() {
  if (isCloudEnvironment()) {
    return window.location.origin;
  }
  return getApiOriginCandidates()[0] || '';
}

export function getNextApiOrigin(currentOrigin, attempted = []) {
  if (isCloudEnvironment()) {
    return null;
  }
  const current = normalizeOrigin(currentOrigin);
  return getApiOriginCandidates().find(
    (candidate) => candidate !== current && !attempted.includes(candidate)
  ) || null;
}

export function persistApiOrigin(origin) {
  if (!isBrowser) return;
  if (isCloudEnvironment()) {
    window.localStorage.removeItem(STORAGE_KEY);
    return;
  }
  const normalized = normalizeOrigin(origin);
  if (!normalized) return;
  window.localStorage.setItem(STORAGE_KEY, normalized);
}
